import LinkExternal from '../LinkExternal';
import LinkInternal from '../LinkInternal';
import LinkExternalMulitple from '../LinkExternalMulitple';
import Item from '../Item';

export default [
	{
		component: Item,
		props: {
			render: new LinkInternal({
				id: 'moreLinks',
				text: 'Ďalšie nárečové zdroje',
			}),
		},
	},
/*
	{
		component: Item,
		props: {
			//render: new LinkExternalMulitple({
			render: new LinkExternal({	
				//hrefLeft: 'https://cja.ujc.cas.cz/e-cja/',
				href: 'https://digiasj4.juls.savba.sk/',
				text: 'Atlas slovenského jazyka (ASJ)',
				//textMain: 'Atlas slovenského jazyka (ASJ)',
				//textLinkLeft: 'nová verze',
				//textLinkRight: 'stará verze'
			}),
		},
	},
	{
		component: Item,
		props: {
			render: new LinkExternal({
				href: 'https://slovnik.juls.savba.sk/?w=&d=ssn',
				text: 'Slovník slovenských nárečí (SSN)',
			}),
		},
	},
	{
		component: Item,
		props: {
			render: new LinkExternal({
				href: 'https://lstn.juls.savba.sk/',
				text: 'Lexika slovenských terénnych názvov',
			}),
		},
	},
*/
	{
		component: Item,
		props: {
			render: new LinkExternal({
				href: 'https://korpus.cz/mapka/',
				text: 'Mapka: mapová aplikace pro korpusy mluvené češtiny (CZ)',
			}),
		},
	},
];